import {
    Context,
    createContext,
    PropsWithChildren,
    ReactElement,
    useCallback,
    useContext,
    useMemo,
    useState,
} from 'react';

import {GalleryPreviewOverlay} from './review-list-page-content/review-list/review/preview-group/gallery-preview-overlay';
import {GalleryMediaItemType} from './review-list-page-content/review-list/review/preview-group/preview-group-media';

type ReviewMediaPreviewContextType = {
    openGallery: (mediaItems: Array<GalleryMediaItemType>, initialIndex: number) => void;
};

const ReviewMediaPreviewContext: Context<ReviewMediaPreviewContextType | null> =
    createContext<ReviewMediaPreviewContextType | null>(null);

type GalleryStateType = {
    initialIndex: number;
    mediaItems: Array<GalleryMediaItemType>;
};

export function useReviewMediaPreview(): ReviewMediaPreviewContextType | null {
    return useContext(ReviewMediaPreviewContext);
}

export function ReviewMediaPreviewProvider(props: PropsWithChildren): ReactElement {
    const {children} = props;
    const [galleryState, setGalleryState] = useState<GalleryStateType | null>(null);

    const openGallery = useCallback((mediaItems: Array<GalleryMediaItemType>, initialIndex: number) => {
        setGalleryState({initialIndex, mediaItems});
    }, []);

    const handleClose = useCallback(() => {
        setGalleryState(null);
    }, []);

    const contextValue = useMemo(() => ({openGallery}), [openGallery]);

    return (
        <ReviewMediaPreviewContext.Provider value={contextValue}>
            {children}
            {galleryState && (
                <GalleryPreviewOverlay
                    initialIndex={galleryState.initialIndex}
                    mediaItems={galleryState.mediaItems}
                    onClose={handleClose}
                />
            )}
        </ReviewMediaPreviewContext.Provider>
    );
}
